import { Form, Formik } from 'formik';
import { FC } from 'react';
import { Button } from '../../../utils/Button';
import * as Yup from 'yup';
import { FormGroupInput } from '../../../utils/form/FormGroupInput';
import InputsValidations from '../../../../InputsValidations';
import {generoDTO} from '../movie.module';
InputsValidations();
const AddMovies: FC = () => {
    const genero:generoDTO[]=[{text:"Acción",value:1},{text:"Comedia",value:2}]
    const dataForm:formMovil = {
        nombre: "",
        imagen: "",
        direccion:"",
        vigente: false,
        genero: 0,
        proximoEstreno:false
    }
    return (
        <>
            <h3>Agregar Pelicula</h3>
            <Formik initialValues={dataForm}
                onSubmit={async values => {
                    await new Promise(r =>setTimeout(r, 1000))
                }}
                validationSchema={Yup.object(
                    { 
                        nombre: Yup.string().required('El campo nombre es requerido').firstCapitalLetter(),
                        direccion : Yup.string().required('El campo dirección es requerido')
                    }
                )}
            >
                {(formikProps) => (
                    <Form className="form-inline">
                        <FormGroupInput
                            campo='nombre'
                            type='text'
                            placeholder='Ingrese nombre'
                        ></FormGroupInput>
                        <FormGroupInput
                            campo='direccion'
                            type='text'
                            placeholder='Ingrese dirección'
                        ></FormGroupInput>
                        <FormGroupInput
                            campo='vigente'
                            type='checkbox'
                            className='form-check-input'
                            label='¿Vigente?'
                        ></FormGroupInput>
                        <div className="form-group mx-sm-3 mb-2">
                            <select className="form-select form-select-lg mb-3" 
                             {...formikProps.getFieldProps('genero')}
                            >
                                <option value="0">--Seleccione genero--</option>
                                {genero.map(item => {
                                    return <option key={item.value} value={item.value}>{item.text}</option>
                                })}
                            </select>
                        </div>
                        <FormGroupInput
                            campo='proximoEstreno'
                            type='checkbox'
                            className='form-check-input'
                            label='Proximo estreno'
                        ></FormGroupInput>
                        <Button
                            type='submit'
                            disabled={formikProps.isSubmitting}
                        >Guardar</Button>
                        <Button
                            className='btn btn-secondary'
                            type='submit'
                            disabled={formikProps.isSubmitting}
                            onClick={() => { formikProps.setValues(dataForm) }}
                        >Limpiar</Button>
                    </Form>
                )}
            </Formik>
        </>
    )
}
interface formMovil{
    nombre: string,
    imagen: string,
    direccion:string,
    vigente: boolean,
    genero: number,
    proximoEstreno:boolean
}
export { AddMovies }